export default "__VITE_ASSET__CkDP7GWH__"